import React from "react";
import requireAuth from "../auth/requireAuth";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { createConta, fetchContas } from "../../actions";
import ContaForm from "./ContaForm";

class ContaCreate extends React.Component {
  onSubmit = (formValues) => {
    this.props.createConta(formValues);
  };

  render() {
    return (
      <div className={"ui container"}>
        <div className={"ui grid"}>
          <div className={"ui row"}>
            <div
              className={
                "ui eight wide left aligned column bottom aligned content"
              }
            >
              <h2>Novo Grupo Empresarial</h2>
            </div>
            <div
              className={
                "ui four wide right aligned column bottom aligned content"
              }
            >
              <h5>Identificação</h5>
            </div>
            <div
              className={
                "ui four wide right aligned column bottom aligned content"
              }
            >
              <Link
                className={"ui mini icon right labeled button"}
                to={"/conta/list"}
              >
                <i aria-hidden="true" className="reply icon" /> Voltar
              </Link>
            </div>
          </div>
        </div>
        <div className={"ui divider"} />
        <ContaForm
          listDocumentValue={this.props.listDocumentValue}
          onSubmit={this.onSubmit}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // Document validation (CNPJ)
    listDocumentValue: Object.values(state.contas).map((conta) => {
      return conta.document;
    }),
  };
};

export default requireAuth(
  connect(mapStateToProps, {
    createConta,
    fetchContas,
  })(ContaCreate)
);
